import styled from "styled-components";

import { Text } from "@ui/Atoms";
import { text } from "@ui/helpers";

export const OfficesList = styled.ul`
  ${text("regular_14")}
  color: ${({ theme }) => theme.palette.grey20};

  display: grid;
  gap: ${({ theme }) => theme.spacing.spacing_32};
  grid-template-columns: repeat(1, 1fr);

  padding: 0;
  margin: 0;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${({ theme }) => theme.breakpointsV2.desktop} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Office = styled.li`
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  font-style: normal;
  list-style: none;
`;

export const OfficeHeader = styled(Text).attrs({
  $style: "bold_14",
  $color: "white",
})``;
